// custom-script.js

// Get the current domain
var currentDomain = window.location.hostname;

// Log the current domain to the console for debugging
console.log('Current Domain:', currentDomain);

// Check if the domain matches the one you want to target
if (currentDomain === 'wayspharmacy.com') {
  // Set a class on the body to target in CSS
  document.body.classList.add('example-domain');
}

// Set data-domain attribute on body
document.body.setAttribute('data-domain', currentDomain);
